const isHttpUrl = (value) => /^https?:\/\//i.test(value);

const getStoredVideoSource = (attestationVideo) => {
  const sources = [attestationVideo?.storagePath, attestationVideo?.url];
  const source = sources.find(
    (value) => typeof value === "string" && value.trim().length > 0,
  );
  return source?.trim() || null;
};

export const resolveAttestationVideoUrl = async (
  attestationVideo,
  getDownloadURL,
) => {
  const source = getStoredVideoSource(attestationVideo);
  if (!source) return null;

  return isHttpUrl(source) ? source : getDownloadURL(source);
};
